import React, { useState } from "react";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { FullProductApiModel } from "lib/@types/service/product/api/product.api.model";

import { getAllDocuments } from "../helpers";
import { InfoBlockHeading } from "../infoBlockHeading/infoBlockHeading.component";
import { DocumentationList } from "./documentationList/documentationList.component";

type DocumentListProps = {
    product: FullProductApiModel;
};

const DocumentList = ({ product }: DocumentListProps) => {
    const { t } = useGranite();
    const [showMobileMore, setShowMobileMore] = useState(false);

    const allDocuments = getAllDocuments(product);

    return (
        <section
            className={`info-block js-info-block js-anchor-scroll-spy__block ${
                showMobileMore ? "info-block--active" : ""
            }`}
        >
            <InfoBlockHeading
                title={t("productDetail.anchor.title.documentation")}
                onClick={() => setShowMobileMore(state => !state)}
            />
            <section className="info-block__content">
                <div className="row">
                    <div className="col-12">
                        <span id="info" className="anchor-span"></span>
                        <h4 className="title mb-3 font-weight-bold anchor--pdp-info-nav">
                            <span
                                className="title__content"
                                data-test={`titleComponent-${t(
                                    "productDetail.anchor.hash.documentation",
                                )}`}
                            >
                                {t("productDetail.anchor.title.documentation")}
                            </span>
                        </h4>
                        <section className="mb-3">
                            <DocumentationList docMap={allDocuments} />
                        </section>
                    </div>
                </div>
            </section>
        </section>
    );
};

export { DocumentList };
